import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';

interface IReturnButtonProps {
    isSketchUp: boolean;
    isRoomSketcher: boolean;

    return: () => void;
    returnSketchUp: () => void;
    returnRoomSketcher: () => void;

    canReturn: boolean;
    canReturnSketchUp: boolean;
    canReturnRoomSketcher: boolean;
}

const ReturnButton = (props: IReturnButtonProps) => {
    if ((props.isSketchUp || props.isRoomSketcher) && props.canReturn) {
        return (
            <Button onClick={props.return} bsStyle="danger">
                {Translate('view-order/admin-planorder/return/button')}
            </Button>
        );
    }

    if (props.isSketchUp && props.isRoomSketcher) {
        return (
            <span>
                {props.canReturnSketchUp && (
                    <Button onClick={props.returnSketchUp} bsStyle="danger">
                        {Translate('view-order/admin-planorder/return/sketchup-button')}
                    </Button>
                )}
                {props.canReturnRoomSketcher && (
                    <Button onClick={props.returnRoomSketcher} bsStyle="danger">
                        {Translate('view-order/admin-planorder/return/roomsketcher-button')}
                    </Button>
                )}
            </span>
        );
    }

    if (props.isSketchUp && props.canReturnSketchUp) {
        return (
            <Button onClick={props.returnSketchUp} bsStyle="danger">
                {Translate('view-order/admin-planorder/return/button')}
            </Button>
        );
    } else if (props.isRoomSketcher && props.canReturnRoomSketcher) {
        return (
            <Button onClick={props.returnRoomSketcher} bsStyle="danger">
                {Translate('view-order/admin-planorder/return/button')}
            </Button>
        );
    }

    return null;
};

export default ReturnButton;
